import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: 'Sarah Jenkins',
    role: 'Health Enthusiast',
    content: "I've been looking for an app like this for years! It makes grocery shopping so much easier. I instantly know what to avoid without reading tiny labels.",
    rating: 5
  }, {
    name: 'Mike Chen',
    role: 'Fitness Coach',
    content: "IntelliEats is a game changer for my clients. The 'Ingredients to Avoid' feature is spot on and helps people make better choices immediately.",
    rating: 5
  }, {
    name: 'Emily Rodriguez',
    role: 'Mom of two',
    content: 'With kids who have allergies, this app is a lifesaver. The scanning is super fast and the breakdown is easy to understand. Highly recommend!',
    rating: 5
  }];
  return <section id="reviews" className="py-20 bg-brand-50/50" data-id="element-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-951">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-952">
          <h2 className="text-3xl sm:text-4xl font-black text-slate-900 mb-4" data-id="element-953">
            Loved by Health-Conscious Eaters
          </h2>
          <p className="text-lg text-slate-600" data-id="element-954">
            Join thousands of users who are taking control of their nutrition.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-955">
          {reviews.map((review, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-slate-100 hover:shadow-md transition-shadow" data-id="element-956">
              <div className="flex text-accent-500 mb-4" data-id="element-957">
                {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-958" />)}
              </div>
              <p className="text-slate-700 mb-6 italic leading-relaxed" data-id="element-959">
                "{review.content}"
              </p>
              <div data-id="element-960">
                <div className="font-bold text-slate-900" data-id="element-961">{review.name}</div>
                <div className="text-sm text-slate-500" data-id="element-962">{review.role}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}